import { useState } from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  const [isServicesOpen, setIsServicesOpen] = useState(false)
  const [isContactOpen, setIsContactOpen] = useState(false)

  return (
    <footer className="footer">
      {/* Footer Top - Company Info */}
      <div className="footer-top">
        <div className="container">
          <div className="footer-content">
            {/* Column 1: Company Info */}
            <div className="footer-section footer-brand-section">
              <div className="footer-logo-container">
                <img src="/assets/logo/logo_footer.png" alt="MAXCONST Logo" className="footer-logo-img" />
                <h3 className="footer-brand-name">MAXCONST</h3>
                <div className="footer-subtitle">THIẾT KẾ & THI CÔNG TRỌN GÓI</div>
                <div className="footer-brand-separator"></div>
              </div>
              <p className="footer-description">
                MAXCONST chuyên thiết kế và thi công các công trình nhà ở, biệt thự, nhà phố, nhà xưởng, nội thất với chất lượng cao, mang đến không gian sống hoàn hảo cho gia đình bạn.
              </p>
              <div className="footer-tagline-wrapper">
                <div className="footer-tagline">
                  Kiến tạo <span className="highlight">giá trị</span> – Xây dựng <span className="highlight">niềm tin</span>
                </div>
              </div>
              <div className="social-links-wrapper">
                <div className="social-links">
                  <a href="https://www.facebook.com/maxhome.chuyengiathicongtrongoi" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="#" className="social-link" aria-label="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#" className="social-link" aria-label="YouTube">
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a href="https://zalo.me/0979808278" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Zalo">
                    <i className="fas fa-comment"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Column 2: Quick Links / Services */}
            <div className="footer-section footer-services-section">
              <h4 
                className="footer-title footer-accordion-header"
                onClick={() => setIsServicesOpen(!isServicesOpen)}
              >
                DỊCH VỤ & THIẾT KẾ
                <i className={`fas fa-chevron-down accordion-chevron ${isServicesOpen ? 'open' : ''}`}></i>
              </h4>
              <ul className={`footer-links-list ${isServicesOpen ? 'mobile-open' : 'mobile-closed'}`}>
                <li className="footer-link-item">
                  <Link to="/nha-vuon">
                    <span className="service-icon"><i className="fas fa-home"></i></span>
                    Thiết kế Nhà vườn
                    <i className="fas fa-chevron-right mobile-link-chevron"></i>
                  </Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/nha-pho">
                    <span className="service-icon"><i className="fas fa-building"></i></span>
                    Thiết kế Nhà phố
                    <i className="fas fa-chevron-right mobile-link-chevron"></i>
                  </Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/biet-thu">
                    <span className="service-icon"><i className="fas fa-hotel"></i></span>
                    Thiết kế Biệt thự
                    <i className="fas fa-chevron-right mobile-link-chevron"></i>
                  </Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/noi-that">
                    <span className="service-icon"><i className="fas fa-couch"></i></span>
                    Thiết kế Nội thất
                    <i className="fas fa-chevron-right mobile-link-chevron"></i>
                  </Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/cong-trinh-thi-cong">
                    <span className="service-icon"><i className="fas fa-tools"></i></span>
                    Công trình thi công
                    <i className="fas fa-chevron-right mobile-link-chevron"></i>
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Contact Info & Map */}
            <div className="footer-section footer-contact-section">
              <h4 
                className="footer-title footer-accordion-header"
                onClick={() => setIsContactOpen(!isContactOpen)}
              >
                THÔNG TIN LIÊN HỆ
                <i className={`fas fa-chevron-down accordion-chevron ${isContactOpen ? 'open' : ''}`}></i>
              </h4>
              <div className={`footer-contact-content ${isContactOpen ? 'mobile-open' : 'mobile-closed'}`}>
                <div className="contact-info-list">
                  <div className="contact-info-item">
                    <i className="fas fa-map-marker-alt contact-icon-gold"></i>
                    <div className="contact-text-wrapper">
                      <span className="contact-item-title">Địa chỉ:</span>
                      <p>37 Đường D3, Khu tái định cư Hố Lang, Khu phố Tân Hiệp, Phường Tân Đông Hiệp, Thành phố Dĩ An, Tỉnh Bình Dương</p>
                    </div>
                  </div>
                  <div className="contact-info-item">
                    <i className="fas fa-phone-alt contact-icon-gold"></i>
                    <div className="contact-text-wrapper">
                      <span className="contact-item-title">Hotline tư vấn:</span>
                      <a href="tel:0979808278">0979.808.278</a>
                    </div>
                  </div>
                  <div className="contact-info-item">
                    <i className="fas fa-envelope contact-icon-gold"></i>
                    <div className="contact-text-wrapper">
                      <span className="contact-item-title">Email:</span>
                      <a href="mailto:vpmaxconst@gmail.com">vpmaxconst@gmail.com</a>
                    </div>
                  </div>
                  <div className="contact-info-item">
                    <i className="fas fa-clock contact-icon-gold"></i>
                    <div className="contact-text-wrapper">
                      <span className="contact-item-title">Giờ làm việc:</span>
                      <p>Thứ 2 - Chủ nhật: 8:00 - 18:00</p>
                    </div>
                  </div>
                </div>

                {/* Styled Google Maps iframe container */}
                <div className="footer-map-wrapper">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3917.081820113446!2d106.7503034!3d10.9572087!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3174d9007a7cebdd%3A0xa93c04caf93dbb35!2zQ8OUTkcgVFkgVE5ISCBUSIBUSVQgS0UgVsOAIFjDglkgRFnhuKRORyBUUsG7Q04gR8G7WEkgTUFYQ09OU1Q!5e0!3m2!1svi!2s!4v1780854000000!5m2!1svi!2s"
                    width="100%"
                    height="130"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="MAXCONST Location Map"
                    className="footer-map-iframe"
                  ></iframe>
                  <a 
                    href="https://maps.app.goo.gl/nePnYwz8M817vinB7" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="footer-map-view-large"
                  >
                    Xem bản đồ lớn <i className="fas fa-external-link-alt"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom - Copyright */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-layout">
            {/* Legal details & copyright */}
            <div className="footer-legal-info">
              <p className="copyright-line">© 2026 MAXCONST Construction. Tất cả quyền được bảo lưu.</p>
              <p className="legal-detail-line">Giấy phép ĐKKD số: 3703093765 do Sở Kế hoạch và Đầu tư tỉnh Bình Dương cấp.</p>
              <p className="legal-detail-line">MST: 3703093765 | Cơ quan quản lý thuế: Thuế cơ sở 26 - Cục Thuế TP. Hồ Chí Minh.</p>
              <div className="footer-bottom-links-row">
                <Link to="/privacy">Chính sách bảo mật</Link>
                <span className="links-separator">|</span>
                <Link to="/terms">Điều khoản sử dụng</Link>
                <span className="links-separator">|</span>
                <Link to="/sitemap">Sơ đồ trang web</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
